import React from 'react';
import {View} from 'react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';

import PercentageProgressListItem from '../PercentageProgressListItem';

import {styles} from './PercentageProgressListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={2}>Checkbox</Heading>
      <Spacer size={16} />
      <Text>
        The checkbox is set with the <Code>{'hasCheckbox'}</Code> prop and the
        checked state is controlled by the <Code>{'isChecked'}</Code> prop.{' '}
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        hasCheckbox
        label={<Text>Group Qualifying Volume</Text>}
      />
    </View>
    <Spacing size={20}>
      <Code>{'hasCheckbox={true}'}</Code>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        label={<Text>Group Qualifying Volume</Text>}
      />
    </View>
    <Spacing size={20}>
      <Code>{'hasCheckbox={false}'}</Code>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        hasCheckbox
        isChecked
        label={<Text>Group Qualifying Volume</Text>}
      />
    </View>
    <Spacing size={20}>
      <Code>{'isChecked={true}'}</Code>
    </Spacing>
  </>
);
